<template>
  <el-dialog title="配置选项" v-model="dialogShow" size="small">
    <div>
      <span v-for="item in configData">
        <el-button class="m-l-10 m-t-10" v-if="item.type == OPERATION_LIST || item.type == OPERATION_CHART" type="primary" @click="goConfig(item)">{{item.name}}</el-button>
        <el-button class="m-l-10 m-t-10" v-else @click="goConfig(item)">{{item.name}}</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import cmsConfig from '../../../config/cmsConfig'
export default {
  name: 'configuration',
  props: {
    configData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogShow: false
    }
  },
  methods: {
    goConfig(item) {
      switch (item.type) {
        case this.OPERATION_LIST: // 列表
          router.push({ name: 'designList', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_CHART: // 图表
          router.push({ name: 'designList', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_IFRAME: // IFrame
          router.push({ name: 'iframeConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_ADD: // 添加/编辑/详情
          router.push({ name: 'formConfig', params: { id: item.id, contentId: item.content_id }, query: { type: this.OPERATION_ADD }})
          break
        // case this.OPERATION_EDIT: // 编辑
        //   router.push({ name: 'editConfig', params: { id: item.id, contentId: item.content_id }})
        //   break
        // case this.OPERATION_DETAIL: // 详情
        //   router.push({ name: 'detailConfig', params: { id: item.id, contentId: item.content_id }})
        //   break
        case this.OPERATION_DELETE: // 删除
          router.push({ name: 'deleteConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_IMPORT: // 导入
          router.push({ name: 'importConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_EXPORT: // 导出
          router.push({ name: 'exportConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_SEARCH: // 搜索
          router.push({ name: 'searchConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_STATUS: // 一键修改字段值
          router.push({ name: 'statusConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_FILTER: // 标签筛选
          router.push({ name: 'filterConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_DOWNLOAD: // 下载
          router.push({ name: 'downloadConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_MESSAGE: // 消息
          router.push({ name: 'messageConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_PARAMS: // 字段扩展管理
          router.push({ name: 'paramsConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_EXEC: // 执行函数
          router.push({ name: 'execConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_SELF: // 定制化功能点
          router.push({ name: 'selfConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_EXPORTWORD: // 导出word文档
          router.push({ name: 'exportWord', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_MULTI_ADD: // 批量写入子表
          router.push({ name: 'formConfig', params: { id: item.id, contentId: item.content_id }, query: { type: this.OPERATION_MULTI_ADD }})
          break
        case this.OPERATION_MULTI_EDIT: // 批量写入子表
          router.push({ name: 'formConfig', params: { id: item.id, contentId: item.content_id }, query: { type: this.OPERATION_MULTI_EDIT }})
          break
        case this.OPERATION_DIMENSIONAL_CHART: // 一维图表
          router.push({ name: 'dimensionalChart', params: { id: item.id, contentId: item.content_id }, query: { type: this.OPERATION_DIMENSIONAL_CHART }})
          break
        case this.OPERATION_DEALGROUP: // 功能点链接集合
          router.push({ name: 'dealGroupConfig', params: { id: item.id, contentId: item.content_id }})
          break
        case this.OPERATION_EMAIL: // 发邮件
          router.push({ name: 'emailConfig', params: { id: item.id, contentId: item.content_id }})
          break
      }
    }
  },
  mixins: [cmsConfig]
}
</script>


// WEBPACK FOOTER //
// configuration.vue?fc4f4300